export default __webpack_public_path__ + "static/media/feature-help-desk-3.18d45b66.png";